import i18n from '@/i18n';

export default [
  {
    path: '/',
    name: 'index',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      title: i18n.global.t('home')
    },
    component: () => import('../../views/Index'),
  },
];
